<div class="zefix-panel" *ngIf="isActive">
    <!-- Header -->
    <div class="zp-header">
        <div class="zp-icon">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
        </div>
        <div class="zp-title-group">
            <div class="zp-label">{{ 'aumico_zefix_search_title' | i18next }}</div>
            <div class="zp-sub">{{ 'aumico_zefix_search_subtitle' | i18next }}</div>
        </div>
        <div class="zp-api-dot">
            <span class="dot-pulse"></span>
            Zefix API
        </div>
    </div>

    <!-- Search Row -->
    <div class="search-row">
        <div class="search-wrap">
            <!-- Search Icon -->
            <span class="s-icon">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
            </span>

            <input
                #searchInputRef
                type="text"
                class="search-input"
                [class.has-value]="hasQuery"
                [formControl]="searchControl"
                [placeholder]="'aumico_zefix_search_placeholder' | i18next"
                autocomplete="off"
                (keydown)="onKeydown($event)"
            />

            <!-- Loading Spinner -->
            <span class="spinner" *ngIf="isLoading">
                <span class="spin-ring"></span>
            </span>

            <!-- Clear Button -->
            <button class="clear-btn" *ngIf="hasQuery && !isLoading" (click)="clearSearch()" type="button">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>

        <!-- UID Mode Badge -->
        <div class="uid-pill" *ngIf="isUidMode">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            {{ 'aumico_zefix_uid_mode' | i18next }}
        </div>
    </div>

    <!-- API Error -->
    <div class="zefix-alert" *ngIf="apiError">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <span>{{ 'aumico_zefix_unavailable' | i18next }}</span>
    </div>

    <!-- Dropdown -->
    <div class="zefix-dropdown" *ngIf="showDropdown && !apiError">
        <!-- Results -->
        <ng-container *ngIf="results.length > 0">
            <div class="dd-header">
                {{ 'aumico_zefix_results_count' | i18next: { count: results.length } }}
            </div>
            <div
                class="dd-item"
                *ngFor="let co of results; let i = index"
                [class.is-active]="i === activeIndex"
                (click)="onSelect(co)"
                (mouseenter)="activeIndex = i"
            >
                <div class="dd-left">
                    <div class="dd-name" [innerHTML]="highlightMatch(co.name, searchControl.value)"></div>
                    <div class="dd-uid">{{ co.uid }}</div>
                </div>
                <div class="dd-right">
                    <div class="dd-lf">{{ co.legalFormText }}</div>
                    <span class="status-pill status-liquid" *ngIf="co.status === 'BEING_CANCELLED'">
                        {{ 'aumico_zefix_status_in_liquidation' | i18next }}
                    </span>
                    <span class="status-pill status-cancel" *ngIf="co.status === 'CANCELLED'">
                        {{ 'aumico_zefix_status_cancelled' | i18next }}
                    </span>
                </div>
            </div>
        </ng-container>

        <!-- No Results -->
        <div class="dd-no-results" *ngIf="results.length === 0 && hasSearched && !isLoading">
            <div class="nf-title">{{ 'aumico_zefix_no_results_title' | i18next }}</div>
            <ul class="nf-reasons">
                <li>{{ 'aumico_zefix_no_results_reason_1' | i18next }}</li>
                <li>{{ 'aumico_zefix_no_results_reason_2' | i18next }}</li>
                <li>{{ 'aumico_zefix_no_results_reason_3' | i18next }}</li>
                <li>{{ 'aumico_zefix_no_results_reason_4' | i18next }}</li>
            </ul>
            <button class="manual-entry-btn" type="button" (click)="onManualEntry()">
                → {{ 'aumico_zefix_manual_entry' | i18next }}
            </button>
        </div>
    </div>
</div>
